export default "__VITE_ASSET__DJI85c8k__"